import { Link } from "react-router-dom";
import { ArrowRight, Cloud, Headset, Landmark, School } from "lucide-react";
import { useTranslation } from "react-i18next";
import HeroBulge from "../HeroBulge/HeroBulge";
import ArrowButton from "../ArrowButton/ArrowButton";
import heroPhoto from "../../assets/redesign/home/hero-estudante.jpg";
import "./HomeHero.css";

const STATS = [
  { key: "institutions", Icon: School, text: "+300 instituições atendidas" },
  { key: "public_sector", Icon: Landmark, text: "Especialistas em setor público" },
  { key: "cloud", Icon: Cloud, text: "Soluções baseadas em Google Cloud" },
  { key: "support", Icon: Headset, text: "Suporte contínuo e consultivo" },
];

// Hero claro com a grade animada (HeroBulge). Título, texto e botões ficam parados; só o fundo
// e as formas atrás da foto (data-bulge="shape") reagem à bolha.
export default function HomeHero() {
  const { t } = useTranslation();

  return (
    <>
      <section className="cz-hero">
        <HeroBulge tone="light" size={0.45} />
        <div className="cz-hero__inner">
          <div className="cz-hero__content">
            <span className="cz-eyebrow cz-hero__eyebrow">
              {t("home.hero_eyebrow", "Tecnologia que transforma realidades")}
            </span>
            <h1 className="cz-hero__title">
              {t("home.hero_title_lead", "Levamos tecnologia unificada para")}{" "}
              <span className="cz-hero__accent">{t("home.hero_title_accent", "empresas e governo.")}</span>
            </h1>
            <p className="cz-hero__text">
              {t("home.hero_description", "Unimos infraestrutura digital, dados, segurança e colaboração para impulsionar uma gestão pública mais eficiente e uma educação mais conectada e inclusiva.")}
            </p>
            <div className="cz-hero__actions">
              <ArrowButton to="#contato" variant="pink" size="md" className="cz-hero__cta">
                {t("home.hero_cta", "Fale com um especialista")}
              </ArrowButton>
              <Link to="/solucoes" className="cz-outline-btn cz-hero__secondary">
                {t("home.hero_cta_secondary", "Conheça nossas soluções")}
                <ArrowRight size={16} aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="cz-hero__visual">
            <span className="cz-hero__blob cz-hero__blob--pink" data-bulge="shape" aria-hidden="true" />
            <span className="cz-hero__blob cz-hero__blob--blue" data-bulge="shape" aria-hidden="true" />
            <span className="cz-hero__blob cz-hero__blob--lilac" data-bulge="shape" aria-hidden="true" />
            <span className="cz-shape cz-shape--drop cz-hero__drop" data-bulge="shape" aria-hidden="true" />
            <img
              src={heroPhoto}
              alt={t("home.hero_img_alt", "Estudante sorrindo com um tablet nas mãos")}
              className="cz-hero__photo"
              width={1000}
              height={1500}
            />
            <p className="cz-hero__quote">
              {t("home.hero_quote", "Mais inovação para uma educação inclusiva e um governo mais eficiente.")}
            </p>
          </div>
        </div>
      </section>

      <div className="cz-hero-stats">
        <ul className="cz-hero-stats__box">
          {STATS.map(({ key, Icon, text }) => (
            <li key={key} className="cz-hero-stats__item">
              <span className="cz-hero-stats__icon" aria-hidden="true">
                <Icon size={22} strokeWidth={1.7} />
              </span>
              <span className="cz-hero-stats__text">{t(`home.stats.${key}`, text)}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
